export const DESKTOP_QUERY = '(pointer: fine)';
